// The handover between a mode screen and the Results screen.
//
// The router uses a MEMORY history (see src/main.js), so there is no query
// string to hang a finished run on and no reload that could carry one. A
// module-level ref is the honest version of what a query string would be
// pretending to do.
//
// Results MUST render without one. QA opens every critical route cold, and a
// results screen that throws on a direct visit fails the run — so `lastResult`
// starting null is a state the screen has to handle, not an impossible one.

import { ref } from 'vue';

export const lastResult = ref(null);

/**
 * @param {object} summary
 * @param {string} summary.mode
 * @param {number} summary.score
 * @param {number} summary.lastedMs
 * @param {number} summary.correct
 * @param {number} summary.wrong
 * @param {number} summary.bestChain
 * @param {number} summary.ausBonuses
 * @param {boolean} summary.isRecord
 * @param {string[]} summary.newTrophies  trophy ids unlocked by this run
 */
export function setResult(summary) {
  lastResult.value = { ...summary, at: Date.now() };
  return lastResult.value;
}

export function clearResult() {
  lastResult.value = null;
}
